import { isAgencyAgentsFeatureEnabledInLocationQuery } from '@/helpers/Directory/featureToggleQueryParams';
import { computed, type ComputedRef } from 'vue';
import { useRoute, type LocationQuery } from 'vue-router';

export enum FeatureToggles {
  AGENCY_AGENTS = 'agency_agents',
}

export const DEFAULT_FEATURES_VALUE: Record<FeatureToggles, boolean> = {
  [FeatureToggles.AGENCY_AGENTS]: false,
};

const useFeatureToggle = (toggle: FeatureToggles): ComputedRef<boolean> => {
  const route = useRoute();

  return computed(() => {
    if (toggle === FeatureToggles.AGENCY_AGENTS) {
      return (
        isAgencyAgentsFeatureEnabledInLocationQuery(route.query) || DEFAULT_FEATURES_VALUE[toggle]
      );
    }

    return route.query[toggle] === 'true' || DEFAULT_FEATURES_VALUE[toggle];
  });
};

/**
 * Feature toggle query parameters of the current route, so that internal links
 * keep the toggles a visitor is testing with instead of falling back to the
 * default experience.
 */
export const useFeatureToggleQuery = (): ComputedRef<LocationQuery> => {
  const route = useRoute();

  return computed(() =>
    Object.values(FeatureToggles).reduce<LocationQuery>((query, toggle) => {
      if (route.query[toggle] !== undefined) {
        query[toggle] = route.query[toggle];
      }

      return query;
    }, {}),
  );
};

export default useFeatureToggle;
